export const DEFAULT_ADD_TEXT = 'Add to short list';
export const DEFAULT_REMOVE_TEXT = 'Remove from short list';
export const MAX_INQUIRY_VENUE_SLOTS = 4;
export const MAX_QUEUE_VENUE_SLOTS = 4;

/** Browse venues card variant: shortlist (default) or queue. */
export const BROWSE_VENUES_CARD_VARIANT_SHORTLIST = 'shortlist';
export const BROWSE_VENUES_CARD_VARIANT_QUEUE = 'queue';
export type BrowseVenuesCardVariant =
    | typeof BROWSE_VENUES_CARD_VARIANT_SHORTLIST
    | typeof BROWSE_VENUES_CARD_VARIANT_QUEUE;
